import React, { useMemo, useContext } from 'react';

import CuratedList from 'components/CuratedList';
import { useCuratedListQuery } from 'hooks/useCuratedListQuery';
import useLiveData from 'hooks/useLiveData';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const CuratedListProvider = ({ staticData, id }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useCuratedListQuery();
	const shouldLimitLiveDataByStaticIds = !staticData;
	const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
	const curatedListEdges = effectiveStaticData?.allSmartTagsCuratedList?.edges || [];
	const curatedListNodes = curatedListEdges.map(({ node }) => node);
	const {
		statusText: curatedListStatusText,
		response: curatedListResponse,
		visibilityChange: curatedListVisibilityChange,
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'CuratedList',
		method: 'all',
		graphqlKey: 'allSmartTagsCuratedList',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Audience',
			...(shouldLimitLiveDataByStaticIds && curatedListNodes.length > 0 ? {
				id: curatedListNodes.map((n) => n.id).join(','),
			} : {}),
			...(!!id ? { id: id } : {}),
		},
		staticData: effectiveStaticData,
	});

	const liveCuratedList = !!id ? curatedListResponse?.data.find((n) => n.id === id) : curatedListResponse?.data[0];
	let curatedList = !!id ? curatedListNodes.find((n) => n.id === id) : curatedListNodes[0];
	if (!!liveCuratedList && curatedListStatusText === 'LOADED') {
		curatedList = liveCuratedList;
	}
	if (!!liveCuratedList && curatedListVisibilityChange) curatedList = liveCuratedList;

	const datum = useMemo(() => curatedList, [curatedList]);

	if (!!datum && datum.hasOwnProperty('Audience') && datum?.Audience) {
		if (!matchAudience(datum?.Audience)) {
			return null;
		}
	}

	return (
		<CuratedList {...datum} matchAudience={matchAudience} />
	);
};

export default CuratedListProvider;